import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import { NamingConventionsIcon, AnalyticsIcon } from '@segment/matcha/components/Icons/Brandbook'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import RobustMarketingAppstoreImage from './RobustMarketingAppstoreImage'

const copy = {
  heading: `Endless opportunities, one centralized platform`,
  description: `Activate your audiences in real-time across ${process.env.INTEGRATION_COUNT}+ integrations.`,
}

const link = {
  text: `Explore Segment Connections`,
  url: `/product/connections/`,
}

const features = [
  {
    heading: `Consistency across channels and campaigns`,
    description: `Use the same audiences & data in all your tools to provide a consistent message across all channels.`,
    icon: <NamingConventionsIcon />,
  },
  {
    heading: `Effortlessly expand your marketing reach`,
    description: `Test new channels for your campaigns instantly, without requiring engineering & analytical oversight.`,
    icon: <AnalyticsIcon />,
  },
]
export const RobustMarketingSection = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <SectionComponent variant="2Col" copyVariant="narrow">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description>{copy.description}</CopyText.Description>
            <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
          </CopyTextBase>

          <ColumnTrackWrapper>
            <ColumnTrack>
              {features.map((feature, index) => (
                <FeatureBoxBase key={index} alignment="left" headerPosition="left">
                  <FeatureBox.Header>
                    <IconWrapper elevation={1} variant="circle">
                      {feature.icon}
                    </IconWrapper>
                  </FeatureBox.Header>
                  <FeatureBox.Body>
                    <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                    <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
          </ColumnTrackWrapper>
        </Section.Copy>

        <SectionContents>
          <RobustMarketingAppstoreImage />
        </SectionContents>
      </SectionComponent>
    </Wrapper>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-bottom: 0px;
    }
  }
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
  max-width: 640px;
`
const Wrapper = styled.section`
  display: grid;
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-bottom: 20px;
  }
`

const SectionContents = styled(Section.Contents)`
  position: relative;

  /**
   * This pseudo element mockups space for absolutely positioned image
   * that needs to overflow outside of the content element.
   */
  &::after {
    content: '';
    display: block;
    height: 0;
    overflow: hidden;
    position: relative;
    pointer-events: none;
    padding-top: 85%;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 80%;
    }
  }
`

export default RobustMarketingSection
